import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { deleteConcern, getConcerns, getDepartment, getTeamConcerns } from '../../service/todo';
import './css/leave_request.css';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import Loader from '../../StaticComponent/Loader';
import { set } from 'react-hook-form';
import { encryptStorage } from '../../constant';

export function ConcernsGrid() {
    const navigate = useNavigate();
    let role = '';
    let Role = encryptStorage.getItem('role');
    let emp_id = encryptStorage.getItem('employeeId');
    if (Role === 'Hr' || Role === 'Hr Manager') {
        role = 'Hr Manager';
    } else {
        role = Role;
    }

    let concernDetails = {
        concern_id: '',
        type: '',
    };

    const { state } = useLocation();

    //PC_CG_02 creating the necessary state variables
    let concernArray = [],
        teamConcernArray = [];
    const [concernData, setConcernData] = useState(concernArray);
    const [teamConcernData, setTeamConcernData] = useState(teamConcernArray);
    const [domainValues, setDomainValues] = useState([]);
    const [columnName, setColumnName] = useState('');
    const [columnOrder, setColumnOrder] = useState('');
    const [teamMemberArrow, setTeamMemberArrow] = useState(true);
    const [domainArrow, setdomainArrow] = useState(true);
    const [reportedArrow, setReportedArrow] = useState(true);
    const [feedbackArrow, setFeedbackArrow] = useState(true);
    const [statusArrow, setStatusArrow] = useState(true);
    const [reportedArrowActive, setReportedArrowActive] = useState(true);
    const [typeArrowActive, setTypeArrowActive] = useState(true);
    const [responseArrowActive, setReponseArrowActive] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [deleteConcernType, setDeleteConcernType] = useState('');
    const [deleteConcernID, setDeleteConcernID] = useState('');
    const [Tab, setTab] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [way, setWay] = useState(0);
    const [hideFilterPopUp, sethideFilterPopUp] = useState(true);

    const [dataLengthTeam, setDataLengthTeam] = useState(0);
    const [dataLengthMy, setDataLengthMy] = useState(0);
    const [limit, setLimit] = useState(10);

    let search = window.location.search;

    const tab = new URLSearchParams(search).get('tab');

    let defaultValue = {
        concern_type_id: '',
        status: '',
        domain: '',
        fromDate: '',
        toDate: '',
    };

    let empDetails = {
        emp_id: emp_id,
        role: role,
        filterData: {
            concern_type_id: '',
            status: '',
            domain: '',
            fromDate: '',
            toDate: '',
        },
        columnName: columnName,
        columnOrder: columnOrder,
        limit: limit,
    };

    const [filter, setfilter] = useState(empDetails);
    const [flag, setFlag] = useState(false);

    let breadCrumbsData1 = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'How Do I ?', isActive: true, path: '' },
        { title: 'Concerns', isActive: false },
    ];

    let breadCrumbsData2 = [
        { title: 'Dashboard', isActive: true, path: '/Overview?tab=activities' },
        { title: 'Team Member', isActive: true, path: '' },
        { title: 'Concerns', isActive: false },
    ];

    //PC_CG_03 loadConcern, loadTeamConcern will be triggered
    useEffect(() => {
        //;
        if (state?.way == 1 && Role != 'Team Member') {
            setActiveTab(state?.way);
            setTab('teamconcern');
        } else {
            setActiveTab(0);
            setTab('');
        }
        loadConcern();
        loadTeamConcern();
        loadDomain();

        if (tab == 'teamconcern') {
            setTab(tab);
            setActiveTab(1);
        }
    }, []);

    useEffect(() => {
        loadConcern();
        loadTeamConcern();
        loadDomain();
    }, [filter, limit]);

    const loadTeamConcern = async (passedLimit = limit) => {
        try {
            //;
            setIsLoading(false);
            teamConcernArray = await getTeamConcerns({ ...filter, limit: passedLimit });

            setTeamConcernData(teamConcernArray?.data);
            setDataLengthTeam(teamConcernArray?.data.count);
            setFlag(!flag);
            setIsLoading(true);
        } catch (error) { }
    };

    const loadConcern = async (passedLimit = limit) => {
        try {
            //;
            setIsLoading(false);
            concernArray = await getConcerns({ ...filter, limit: passedLimit });

            setConcernData(concernArray?.data);
            setDataLengthMy(concernArray?.data.length);
            setIsLoading(true);
        } catch (error) { }
    };

    const handleLoadMore = (value) => {
        try {
            setLimit(limit + 10);

            if (value == 'team') {
                loadTeamConcern(limit + 10);
            }
            if (value == 'my') {
                loadConcern(limit + 10);
            }
        } catch (error) { }
    };

    const viewClicked = async (concern) => {
        navigate(`/concernView/`, { state: { concern } });
    };

    const bindTeamConcerns = () => {
        return teamConcernData?.map((obj, index) => {
            let m = moment(new Date(obj.created_at));
            let date = m.format('MMM DD, YYYY');
            let teamConcern = {
                type: obj.concern_type_id,
                concern_id: obj.id,
                way: 1,
            };

            let statusColor;

            if (obj.status === 'Pending') {
                statusColor = `bg-pastel-orange`;
            } else if (obj.status === 'Solved') {
                statusColor = `bg-pastel-green`;
            } else {
                statusColor = `bg-pastel-red`;
            }
            return (
                <tr className="hive-table-data regular-text align-middle">
                    <td>
                        <div className="d-flex align-items-center">
                            <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="table-image" />
                            <div className="ms-2">
                                <a className="table-name-style mb-0">{obj.emp_name}</a>
                                <p className="table-domain-style mb-0">{obj.domain}</p>
                            </div>
                        </div>
                    </td>
                    {role === 'Hr Manager' ? <td>{obj.domain}</td> : ''}
                    <td>{date}</td>
                    <td>{obj.phone_num}</td>
                    <td>{obj.concern_type}</td>
                    <td className="text-center bold-text">
                        <span class={`status-btn ${statusColor} font-12`}>{obj.status}</span>
                    </td>
                    <td className="text-center">
                        <a
                            onClick={() => {
                                viewClicked(teamConcern);
                            }}
                            className="text-decoration-none table-link-clr"
                        >
                            View
                        </a>
                    </td>
                </tr>
            );
        });
    };

    const bindMyConcerns = () => {
        if (activeTab == 0) {
            if (concernData?.length === 0 || concernData?.length === undefined) {
                return (
                    <div class="row justify-content-center">
                        <img src="/Images/nodatafound.png" alt="no-records" style={{ width: '750px', height: '500px' }} />
                        <span class="row justify-content-center margin-negative">No Concerns found</span>
                    </div>
                );
            } else {
                return concernData?.map((obj, index) => {
                    let m = moment(new Date(obj.created_at));
                    let date = m.format('MMM DD, YYYY');

                    let myConcern = {
                        type: obj.concern_type_id,
                        concern_id: obj.id,
                        way: 0,
                    };
                    let statusColor;

                    if (obj.status === 'Pending') {
                        statusColor = `bg-pastel-orange`;
                    } else if (obj.status === 'Solved') {
                        statusColor = `bg-pastel-green`;
                    } else {
                        statusColor = `bg-pastel-red`;
                    }

                    return (
                        <tr className="hive-table-data regular-text align-middle">
                            <td>{date}</td>
                            <td>{obj.concern_type}</td>
                            <td className="text-center bold-text ">
                                <span className={`status-btn ${statusColor} font-12`}>{obj.status}</span>
                            </td>
                            <td class="text-center">
                                <a
                                    class="text-decoration-none table-link-clr"
                                    onClick={() => {
                                        viewClicked(myConcern);
                                    }}
                                >
                                    View
                                </a>
                                {obj.status === 'Pending' ? (
                                    <>
                                        <span class="mx-3">
                                            <img
                                                src="Images/hive-edit-icon.svg"
                                                alt="edit"
                                                onClick={(e) => editClicked(e)}
                                                name={obj.concern_type_id}
                                                id={obj.id}
                                            />
                                        </span>
                                        <span>
                                            <img
                                                src="Images/hive-delete-icon.svg"
                                                onClick={(e) => {
                                                    setDeleteConcernType(e.target.name);
                                                    setDeleteConcernID(e.target.id);
                                                }}
                                                data-bs-toggle="modal"
                                                data-bs-target="#logout"
                                                alt="delete"
                                                name={obj.concern_type_id}
                                                id={obj.id}
                                            />
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span class="mx-3">
                                            <img src="Images/edit-disabled.svg" alt="edit" />
                                        </span>
                                        <span>
                                            <img src="Images/delete-disabled.svg" alt="delete" />
                                        </span>
                                    </>
                                )}
                            </td>
                        </tr>
                    );
                });
            }
        }
    };

    const editClicked = async (e) => {
        //;
        concernDetails = {
            concern_id: e.target.id,
            type: e.target.name,
            pMode: 'edit',
        };
        navigate(`/concernForm/`, { state: { concernDetails } });
    };

    const loadDomain = async (e) => {
        try {
            setIsLoading(false);
            let domainArray = await getDepartment();
            setDomainValues(domainArray?.data);
            setIsLoading(true);
        } catch (error) { }
    };

    const bindDomain = () => {
        return domainValues?.map((obj, index) => {
            return <option value={obj.id}>{obj.department}</option>;
        });
    };

    const handleSort = (e) => {
        //
        var splitt = e.target.name.split('-');
        filter.columnName = splitt[0];
        filter.columnOrder = splitt[1];
        setColumnName(splitt[0]);
        setColumnOrder(splitt[1]);
        if (activeTab === 0) {
            loadConcern();
        } else {
            loadTeamConcern();
        }
    };

    const filterClicked = () => {
        //;
        sethideFilterPopUp(true);
        if (activeTab === 1) {
            //
            loadTeamConcern();
        } else {
            //
            loadConcern();
        }
    };

    const clearFilter = () => {
        setfilter((filter) => ({ ...filter, filterData: defaultValue }));
        sethideFilterPopUp(true);
        //;
        if (activeTab) {
            //;
            loadTeamConcern();
        } else {
            loadConcern();
        }
    };

    const deleteClicked = async () => {
        //
        concernDetails = {
            concern_id: deleteConcernID,
            type: deleteConcernType,
        };
        setIsLoading(false);
        let response = await deleteConcern(concernDetails);

        setIsLoading(true);
        if (response.message === 'Data Deleted Successfully') {
            loadConcern();
        }
    };

    const redirect = () => {
        concernDetails = {
            type: 1,
        };
        navigate(`/concernForm`, { state: { concernDetails } });
    };

    const filterClickedtab = async () => {
        try {
            sethideFilterPopUp(hideFilterPopUp == true ? false : true);
        } catch (error) {
            //window.location.href = '/ErrorPage';
        }
    };

    const showTeamConcerns = () => {
        try {
            return (
                <div
                    className={activeTab == 1 || Tab == 'teamconcern' ? `tab-pane fade show active` : `tab-pane fade`}
                    id="team_concerns"
                    role="tabpanel"
                    aria-labelledby="team_concerns_tab"
                >
                    <div className="table-responsive rounded-3 container-fluid">
                        <table className="table bg-white hive-grid table-borderless ">
                            <thead
                                className="hive-table-head"
                                hidden={teamConcernData.length === 0 || teamConcernData.length === undefined ? true : false}
                            >
                                <tr>
                                    <th className="bold-text font-12">
                                        Team Members Name
                                        {teamMemberArrow === true ? (
                                            <>
                                                <span className="ps-2">
                                                    <img
                                                        onClick={(e) => {
                                                            handleSort(e);
                                                            setTeamMemberArrow(false);
                                                        }}
                                                        src="Images/sort-icon.svg"
                                                        alt="Sorticon"
                                                        name="emp_name-asc"
                                                        className="hive-table-sort"
                                                    />
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <img
                                                    onClick={(e) => {
                                                        handleSort(e);
                                                        setTeamMemberArrow(true);
                                                    }}
                                                    src="Images/Sort-up.svg"
                                                    class="ps-2 hive-table-sort"
                                                    name="emp_name-desc"
                                                    alt="arrow"
                                                />
                                            </>
                                        )}
                                    </th>
                                    {role === 'Hr Manager' ? (
                                        <th className="bold-text font-12">
                                            Domain
                                            {domainArrow === true ? (
                                                <>
                                                    <span className="ps-2">
                                                        <img
                                                            onClick={(e) => {
                                                                handleSort(e);
                                                                setdomainArrow(false);
                                                            }}
                                                            src="Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            name="domain-asc"
                                                            className="hive-table-sort"
                                                        />
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <img
                                                        onClick={(e) => {
                                                            handleSort(e);
                                                            setdomainArrow(true);
                                                        }}
                                                        src="Images/Sort-up.svg"
                                                        class="ps-2 hive-table-sort"
                                                        name="domain-desc"
                                                        alt="arrow"
                                                    />
                                                </>
                                            )}
                                        </th>
                                    ) : (
                                        ''
                                    )}
                                    <th className="bold-text font-12">
                                        Reported Date
                                        {reportedArrow === true ? (
                                            <>
                                                <span className="ps-2">
                                                    <img
                                                        onClick={(e) => {
                                                            handleSort(e);
                                                            setReportedArrow(false);
                                                        }}
                                                        src="Images/sort-icon.svg"
                                                        alt="Sorticon"
                                                        name="created_at-asc"
                                                        className="hive-table-sort"
                                                    />
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <img
                                                    onClick={(e) => {
                                                        handleSort(e);
                                                        setReportedArrow(true);
                                                    }}
                                                    src="Images/Sort-up.svg"
                                                    class="ps-2 hive-table-sort"
                                                    name="created_at-desc"
                                                    alt="arrow"
                                                />
                                            </>
                                        )}
                                    </th>
                                    <th className="bold-text font-12">Phone Number</th>
                                    <th className="bold-text font-12">
                                        Feedback Type
                                        {feedbackArrow === true ? (
                                            <>
                                                <span className="ps-2">
                                                    <img
                                                        onClick={(e) => {
                                                            handleSort(e);
                                                            setFeedbackArrow(false);
                                                        }}
                                                        src="Images/sort-icon.svg"
                                                        alt="Sorticon"
                                                        name="concern_type-asc"
                                                        className="hive-table-sort"
                                                    />
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <img
                                                    onClick={(e) => {
                                                        handleSort(e);
                                                        setFeedbackArrow(true);
                                                    }}
                                                    src="Images/Sort-up.svg"
                                                    class="ps-2 hive-table-sort"
                                                    name="concern_type-desc"
                                                    alt="arrow"
                                                />
                                            </>
                                        )}
                                    </th>
                                    <th className="text-center bold-text font-12">
                                        Status
                                        {statusArrow === true ? (
                                            <>
                                                <span className="ps-2">
                                                    <img
                                                        onClick={(e) => {
                                                            handleSort(e);
                                                            setStatusArrow(false);
                                                        }}
                                                        src="Images/sort-icon.svg"
                                                        alt="Sorticon"
                                                        name="status-asc"
                                                        className="hive-table-sort"
                                                    />
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <img
                                                    onClick={(e) => {
                                                        handleSort(e);
                                                        setStatusArrow(true);
                                                    }}
                                                    src="Images/Sort-up.svg"
                                                    class="ps-2 hive-table-sort"
                                                    name="status-desc"
                                                    alt="arrow"
                                                />
                                            </>
                                        )}
                                    </th>
                                    <th className="text-center bold-text font-12">Action</th>
                                </tr>
                            </thead>
                            <tbody>{teamConcernData.length > 0 ? bindTeamConcerns() : null}</tbody>
                        </table>
                        {teamConcernData.length == 0 ? (
                            <>
                                <div className="row justify-content-center">
                                    <img src="/Images/nodatafound.png" alt="no-records" style={{ width: '750px', height: '500px' }} />
                                    <span class="row justify-content-center margin-negative">No Team Concerns found</span>
                                </div>
                            </>
                        ) : null}
                    </div>
                    <div className="text-center">
                        {dataLengthTeam > limit ? (
                            <button
                                className="btn show-more-btn cursor-pointer !important"
                                style={{ backgroundColor: 'white' }}
                                onClick={() => handleLoadMore('team')}
                            >
                                Show More
                            </button>
                        ) : null}
                    </div>
                </div>
            );

            //}
        } catch (error) { }
    };

    const handleFilterData = (e) => {
        let obj = filter;
        obj['filterData'] = { ...obj['filterData'], [e.target.name]: e.target.value };
        setfilter(obj);
        setFlag(!flag);
    };

    // const infoForShowMore = (countResult, countToDivid) => {
    //     let count = countResult;
    //     let result = count / countToDivid;
    //     setShowMore(result == 1 || result < 1 ? false : true);
    // };

    return (
        <div>
            <Loader isLoading={isLoading} />
            <link rel="icon" href="Images/Hive_logo.png" type="image/x-icon" />
            <div className="container-fluid">
                <div className="row justify-content-center mt-5 ">
                    <div className="col-md-11 d-flex align-items-center mt-4 ">
                        {Role === 'Team Member' ? <BreadCrumbs data={breadCrumbsData1} /> : <BreadCrumbs data={breadCrumbsData2} />}
                    </div>
                    <div className="col-md-11 d-flex align-items-center ">
                        {/*Tab Structure Starts Here*/}
                        <ul className="nav nav-pills " id="pills-tab" role="tablist">
                            {/* {empDetails.role !== 'Team Member' ? */}
                            <li className="nav-item">
                                <button
                                    onClick={() => {
                                        setActiveTab(0);
                                        sethideFilterPopUp(true);
                                        clearFilter();
                                        setLimit(10);
                                    }}
                                    className={`nav-link ${Tab == '' ? 'active' : null} rounded-0 font-14 bold-text tab-style me-4`}
                                    id="my_concerns_tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#my_concerns"
                                    type="button"
                                    role="tab"
                                    aria-controls="my_concerns"
                                    aria-selected="true"
                                >
                                    My Concern
                                </button>
                            </li>
                            {/* // <p className="bold-text">Concern</p> */}
                            {/* } */}
                            {empDetails.role === 'Hr Manager' || empDetails.role === 'Manager' ? (
                                <li className="nav-item">
                                    <button
                                        onClick={() => {
                                            setActiveTab(1);
                                            sethideFilterPopUp(true);
                                            clearFilter();
                                            setLimit(10);
                                        }}
                                        className={`nav-link ${Tab == 'teamconcern' ? 'active' : null
                                            } rounded-0 font-14 bold-text tab-style me-4`}
                                        id="team_concerns_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#team_concerns"
                                        type="button"
                                        role="tab"
                                        aria-controls="team_concerns"
                                        aria-selected="false"
                                    >
                                        Team Concerns
                                    </button>
                                </li>
                            ) : null}
                        </ul>
                        {/*Tab Structure Ends Here*/}
                        <div className="ms-auto d-flex">
                            {/*Filter Section Starts Here*/}
                            <div className="dropdown">
                                <button
                                    className="advanced-filter-button custom-padding me-3 medium-text"
                                    type="button"
                                    onClick={() => filterClickedtab()}
                                >
                                    <img src="Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                    Filter
                                </button>
                                {!hideFilterPopUp ? (
                                    <div
                                        className="dropdown-menu px-3 advanced-filter-panel"
                                        aria-labelledby="dropdownMenuButton1"
                                        style={{ display: 'block' }}
                                    >
                                        <div className="row">
                                            <div className="col-md-12 py-2 border-0 mb-1">
                                                <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                <button
                                                    type="button"
                                                    className="btn-close float-end close-filter"
                                                    data-bs-dismiss="advanced-filter"
                                                    aria-label="Close"
                                                    onClick={() => sethideFilterPopUp(true)}
                                                />
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="row mb-3">
                                                    {role === 'Hr Manager' ? (
                                                        <div hidden={activeTab === 1 ? false : true} className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="Domain">
                                                                Domain
                                                            </label>
                                                            <select
                                                                value={filter.filterData.domain}
                                                                name="domain"
                                                                onChange={(e) => {
                                                                    handleFilterData(e);
                                                                }}
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example2"
                                                                id="domain"
                                                            >
                                                                <option value={''}>Select</option>
                                                                {bindDomain()}
                                                            </select>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="concern_type_id">
                                                            Type
                                                        </label>
                                                        <select
                                                            value={filter.filterData.concern_type_id}
                                                            name="concern_type_id"
                                                            onChange={(e) => {
                                                                handleFilterData(e);
                                                            }}
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="concern_type_id"
                                                        >
                                                            <option value={''}>Select</option>
                                                            <option value={1}>Feedback</option>
                                                            <option value={2}>Complaint against Lead / Manager</option>
                                                            <option value={3}>Harassement Issues</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="concern_status">
                                                            Status
                                                        </label>
                                                        <select
                                                            value={filter.filterData.status}
                                                            name="status"
                                                            onChange={(e) => {
                                                                handleFilterData(e);
                                                            }}
                                                            className="form-select hive-form-select"
                                                            aria-label="Default select example2"
                                                            id="concern_status"
                                                        >
                                                            <option value={''}>Select</option>
                                                            <option value={'Pending'}>Pending</option>
                                                            <option value={'Solved'}>Solved</option>
                                                            <option value={'Closed'}>Closed</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 pb-2 border-0 ">
                                                    <span className="font-14 semibold-text filter-title">Date Range</span>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="fromDate">
                                                            From
                                                        </label>
                                                        <input
                                                            value={filter.filterData.fromDate}
                                                            name="fromDate"
                                                            max={filter.filterData.toDate}
                                                            onChange={(e) => {
                                                                handleFilterData(e);
                                                            }}
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="fromDate"
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="toDate">
                                                            To
                                                        </label>
                                                        <input
                                                            value={filter.filterData.toDate}
                                                            name="toDate"
                                                            min={filter.filterData.fromDate}
                                                            onChange={(e) => {
                                                                handleFilterData(e);
                                                            }}
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="toDate"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 my-3 d-flex justify-content-end">
                                                <button
                                                    onClick={() => {
                                                        clearFilter();
                                                    }}
                                                    className="btn hive-btn-secondary me-3"
                                                >
                                                    Clear
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        filterClicked();
                                                    }}
                                                    className="btn hive-btn-primary"
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                            {/*Filter Section Ends Here*/}
                            {activeTab == 1 ? null : (
                                <button
                                    className="btn hive-btn-primary"
                                    onClick={() => {
                                        redirect();
                                    }}
                                >
                                    <img src="Images/hive-add-icon.svg" className="me-2" alt="" />
                                    Raise a Concern
                                </button>
                            )}
                        </div>
                    </div>
                    {/*Tab Content Starts Here*/}
                    <div className="col-md-11 mt-4">
                        <div className="tab-content" id="pills-tabContent">
                            {/*My Concerns Section Starts Here*/}
                            {
                                <div
                                    className={activeTab == 0 || Tab == '' ? `tab-pane fade show active` : `tab-pane fade`}
                                    id="my_concerns"
                                    role="tabpanel"
                                    aria-labelledby="my_concerns_tab"
                                >
                                    {/* <div className="table-responsive rounded-3" hidden={activeTab === 0 ? true : false}> */}
                                    <div className="table-responsive rounded-3 container-fluid">
                                        {concernData.length > 0 && activeTab == 0 ? (
                                            <table className="table bg-white hive-grid table-borderless ">
                                                <thead className="hive-table-head ">
                                                    <tr>
                                                        <th className="bold-text font-12">
                                                            Reported Date
                                                            {reportedArrowActive === true ? (
                                                                <>
                                                                    <span className="ps-2">
                                                                        <img
                                                                            onClick={(e) => {
                                                                                handleSort(e);
                                                                                setReportedArrowActive(false);
                                                                            }}
                                                                            name="created_at-desc"
                                                                            src="Images/sort-icon.svg"
                                                                            alt="Sorticon"
                                                                            className="hive-table-sort"
                                                                        />
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img
                                                                        onClick={(e) => {
                                                                            handleSort(e);
                                                                            setReportedArrowActive(true);
                                                                        }}
                                                                        src="Images/Sort-up.svg"
                                                                        class="ps-2 hive-table-sort"
                                                                        name="created_at-asc"
                                                                        alt="arrow"
                                                                        id=""
                                                                    />
                                                                </>
                                                            )}
                                                        </th>
                                                        <th className="bold-text font-12">
                                                            Type of Concern
                                                            {typeArrowActive === true ? (
                                                                <>
                                                                    <span className="ps-2">
                                                                        <img
                                                                            onClick={(e) => {
                                                                                handleSort(e);
                                                                                setTypeArrowActive(false);
                                                                            }}
                                                                            name="concern_type-asc"
                                                                            src="Images/sort-icon.svg"
                                                                            alt="Sorticon"
                                                                            className="hive-table-sort"
                                                                        />
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img
                                                                        onClick={(e) => {
                                                                            handleSort(e);
                                                                            setTypeArrowActive(true);
                                                                        }}
                                                                        src="Images/Sort-up.svg"
                                                                        class="ps-2 hive-table-sort"
                                                                        name="concern_type-desc"
                                                                        alt="arrow"
                                                                        id=""
                                                                    />
                                                                </>
                                                            )}
                                                        </th>
                                                        <th className="text-center bold-text font-12">
                                                            Team Response
                                                            {responseArrowActive === true ? (
                                                                <>
                                                                    <span className="ps-2">
                                                                        <img
                                                                            onClick={(e) => {
                                                                                handleSort(e);
                                                                                setReponseArrowActive(false);
                                                                            }}
                                                                            name="status-asc"
                                                                            src="Images/sort-icon.svg"
                                                                            alt="Sorticon"
                                                                            className="hive-table-sort"
                                                                        />
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img
                                                                        onClick={(e) => {
                                                                            handleSort(e);
                                                                            setReponseArrowActive(true);
                                                                        }}
                                                                        src="Images/Sort-up.svg"
                                                                        class="ps-2 hive-table-sort"
                                                                        name="status-desc"
                                                                        alt="arrow"
                                                                        id=""
                                                                    />
                                                                </>
                                                            )}
                                                        </th>
                                                        <th colSpan={3} className="text-center bold-text font-12">
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>{concernData !== undefined ? bindMyConcerns() : null}</tbody>
                                            </table>
                                        ) : activeTab == 0 ? (
                                            <div className="row justify-content-center">
                                                <img
                                                    src="/Images/nodatafound.png"
                                                    alt="no-records"
                                                    style={{ width: '750px', height: '500px' }}
                                                />
                                                <span class="row justify-content-center margin-negative">No Concerns found</span>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="text-center">
                                        { }
                                        {dataLengthMy > limit ? (
                                            <button
                                                className="btn show-more-btn cursor-pointer !important"
                                                style={{ backgroundColor: 'white' }}
                                                onClick={() => handleLoadMore('my')}
                                            >
                                                Show More
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            }

                            {/* { activeTab === 1 ? ((empDetails.role == 'Hr Manager' || empDetails.role == 'Manager') ? showTeamConcerns() : null): null } */}
                            {empDetails.role === 'Hr Manager' || empDetails.role === 'Manager' ? showTeamConcerns() : null}
                            {/*Team Concerns Section Ends Here*/}
                        </div>

                        {/*Tab Content Ends Here*/}
                        <div className="modal fade" id="logout" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-position">
                                <div className="modal-content border-none">
                                    <div className="row">
                                        <div className="col-md-12 float-start text-center p-5">
                                            <img
                                                className="mb-3 text-center align-items-center"
                                                src="Images/question-mark.svg"
                                                alt="alert"
                                            />
                                            <label className="w-100 bold-text font-14 text-center mb-3">
                                                Are you sure you want to Delete?
                                            </label>
                                            <div className="col-md-12 float-start text-center">
                                                <button type="button" className="btn hive-btn-error" data-bs-dismiss="modal">
                                                    No
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        deleteClicked();
                                                    }}
                                                    className="btn hive-btn-secondary"
                                                    data-bs-dismiss="modal"
                                                >
                                                    Yes
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
